import { take, cancel, call, fork } from 'redux-saga/effects';
import { delay } from 'redux-saga';

/**
 * Debounce a saga for X milliseconds
 *
 * Shameless taken from https://github.com/madewithlove/redux-saga-debounce-effect
 *
 * @param {Number} ms
 * @param {String|Array|Function} pattern
 * @param {Function} saga
 * @param {Array} args
 */
export default function* debounce(ms, pattern, saga, ...args) {
    function* delayedSaga(action) {
        yield call(delay, ms);
        yield call(saga, ...args, action);
    }

    let task;
    while (true) {
        const action = yield take(pattern);
        if (task) {
            yield cancel(task);
        }

        task = yield fork(delayedSaga, action);
    }
}

/**
 * Throttle a saga for X milliseconds
 * Tosses all additional calls to the given pattern for a given time
 *
 * NOTE: Includes a short 5 ms delay at the front of the run saga
 *
 * @param {Number} ms
 * @param {String|Array|Function} pattern
 * @param {Function} saga
 * @param {Array} args
 */
export function* throttle(ms, pattern, saga, ...args) {
    function* delayedSaga(action) {
        yield call(delay, 5);
        yield call(saga, ...args, action);
        yield call(delay, ms);
    }

    let task;
    while (true) {
        const action = yield take(pattern);
        if (task) {
            yield cancel(task);
        }

        task = yield fork(delayedSaga, action);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/sagaEffects.js